import { Paragraph5 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import mq from '../../../../../commons/styles/mediaQueries';
import styled from '../../../../../theme/styled';

const BannerContainer = styled.div`
  padding: 0 8px 8px;
  width: 100%;

  ${mq.desktop} {
    padding: 0;
  }
`;

const BannerCentralizer = styled.div`
  margin: auto;
  max-width: 2072px;
`;

const MessageBlock = styled.div`
  display: flex;
  flex-direction: column;

  ${mq.desktop} {
    flex-direction: row;
  }
`;

const WarningMessage = styled(Paragraph5)`
  font-family: ${({ theme }) => theme.fonts.primary};
  width: 100%;
`;

export default {
  BannerContainer,
  BannerCentralizer,
  WarningMessage,
  MessageBlock,
};
